<template>
  <div class="app-single-top-up-wrapper">
    <slot name="txtBefore"></slot>
    <SingleTopUpAmountSelector
      v-if="showAmountSelector"
      :amounts="singleTopUpStatus.amounts.amount"
      :default-amount="singleTopUpStatus.amounts.default"
      :next-step="secondStep"
    >
      <template #txtBefore><slot name="txtBeforeAmount"></slot></template>
      <template #lblAmount><slot name="lblAmountAmount"></slot></template>
      <template #btnNext><slot name="btnNextAmount"></slot></template>
      <template #txtAfter><slot name="txtAfterAmount"></slot></template>
    </SingleTopUpAmountSelector>
    <SingleTopUpBankTransfer
      v-if="showBankTransfer"
    >
      <template #txtBefore><slot name="txtBeforeBankTransfer"></slot></template>
      <template #txtTransfer><slot name="txtTransferBankTransfer"></slot></template>
      <template #txtAdditional><slot name="txtAdditionalBankTransfer"></slot></template>
      <template #btnPrev><slot name="btnPrevBankTransfer"></slot></template>
      <template #txtAfter><slot name="txtAfterBankTransfer"></slot></template>
    </SingleTopUpBankTransfer>
    <SingleTopUpConfirm
      v-if="showConfirmation"
      :payment="singleTopUpStatus.payment"
    >
      <template #txtBefore><slot name="txtBeforeConfirm"></slot></template>
      <template #lblAmount><slot name="lblAmountConfirm"></slot></template>
      <template #txtBeforePayment><slot name="txtBeforePaymentConfirm"></slot></template>
      <template #txtBeforeCreditCardPayment><slot name="txtBeforeCreditCardPaymentConfirm"></slot></template>
      <template #lblCcHolderCreditCardPayment><slot name="lblCcHolderCreditCardPaymentConfirm"></slot></template>
      <template #lblCcNumberCreditCardPayment><slot name="lblCcNumberCreditCardPaymentConfirm"></slot></template>
      <template #lblCcTypeCreditCardPayment><slot name="lblCcTypeCreditCardPaymentConfirm"></slot></template>
      <template #lblCcValidtyCreditCardPayment><slot name="lblCcValidtyCreditCardPaymentConfirm"></slot></template>
      <template #txtAfterCreditCardPayment><slot name="txtAfterCreditCardPaymentConfirm"></slot></template>
      <template #txtErrorCreditCardPayment><slot name="txtErrorCreditCardPaymentConfirm"></slot></template>
      <template #txtBeforeBankAccountPayment><slot name="txtBeforeBankAccountPaymentConfirm"></slot></template>
      <template #lblOwnerBankAccountPayment><slot name="lblOwnerBankAccountPaymentConfirm"></slot></template>
      <template #lblIbanBankAccountPayment><slot name="lblIbanBankAccountPaymentConfirm"></slot></template>
      <template #txtAfterBankAccountPayment><slot name="txtAfterBankAccountPaymentConfirm"></slot></template>
      <template #txtAfterPayment><slot name="txtAfterPaymentConfirm"></slot></template>
      <template #btnPrev><slot name="btnPrevConfirm"></slot></template>
      <template #btnNext><slot name="btnNextConfirm"></slot></template>
      <template #txtAfter><slot name="txtAfterConfirm"></slot></template>
    </SingleTopUpConfirm>
    <Success
      v-if="showSuccess"
    >
      <template #txtBefore><slot name="txtBeforeSuccess"></slot></template>
      <template #txtSuccess><slot name="txtSuccess"></slot></template>
      <template #btnPrev><slot name="btnPrevSuccess"></slot></template>
      <template #txtAfter><slot name="txtAfterSuccess"></slot></template>
    </Success>
    <slot name="txtAfter"></slot>
  </div>
</template>
<script>

import { wrapQuery } from '../../../../../helper/wrapGQLQuery'
import gql from 'graphql-tag'
import SingleTopUpAmountSelector, { stepName as selector } from './AmountSelector.vue'
import SingleTopUpBankTransfer, { stepName as bankTransfer } from './BankTransfer.vue'
import SingleTopUpConfirm, { stepName as confirm } from './Confirm.vue'
import Success, { stepName as success } from './Success.vue'
import { mapGetters } from 'vuex'
import transaction from '@/mixins/transaction'

export default {
  name: 'SingleTopUpWrapper',
  components: { Success, SingleTopUpConfirm, SingleTopUpBankTransfer, SingleTopUpAmountSelector },
  data () {
    return {
      singleTopUpStatus: {
        amounts: {
          amount: [],
          default: null
        },
        directPossible: false,
        payment: {}
      }
    }
  },
  computed: {
    ...mapGetters('topUp/single', [
      'currentStep'
    ]),
    showAmountSelector () {
      return this.currentStep === selector
    },
    showBankTransfer () {
      return this.currentStep === bankTransfer
    },
    showConfirmation () {
      return this.currentStep === confirm
    },
    showSuccess () {
      return this.currentStep === success
    },
    secondStep: function () {
      if (this.singleTopUpStatus.directPossible) {
        return confirm
      }
      return bankTransfer
    }
  },
  mixins: [
    transaction('singleTopUp')
  ],
  apollo: {
    singleTopUpStatus: function () {
      return wrapQuery(
        gql`query singleTopUp {
          singleTopUpStatus {
            directPossible
            amounts {
              amount
              default
            }
            payment {
              ...on BankAccount {
                type
                iban
                owner
              }
              ...on CreditCard {
                type
                holder
                company
                expiryMonth
                expiryYear
                lastDigits
              }
            }
          }
        }`, this, 'singleTopUpStatus', {}, null,
        {
          fetchPolicy: 'cache-first'
        }
      )
    }
  }
}
</script>
